import { isEmpty } from 'lodash';

export default function mappingLanguage(objMapping, key) {
  const currLang = localStorage.getItem('i18nextLng');

  return !isEmpty(objMapping) ? objMapping[`${key}${currLang.toUpperCase()}`] : '';
}